import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface I_BottomProp {
    children: JSX.Element;
    side?: string;
}

const BottomSlide: React.FC<I_BottomProp> = ({ children, side }) => {
    const modalRoot = document.body;

    return side !== 'bottom' ? children : ReactDOM.createPortal(children, modalRoot!);
};

export default BottomSlide;
